import { css } from '@emotion/react';
import type { RefObject } from 'react';

import IconEye from '~icons/bi/eye';
import IconEyeSlash from '~icons/bi/eye-slash';

import { theme } from '@adflow/frontend/ui-theme';

const iconStyle = css({
	color: theme.colors.lightBlue,
	marginLeft: '0.5rem',
	cursor: 'pointer',
});

interface VisibilityToggleProps {
	visible: boolean;
	setVisible: (visible: boolean) => void;
	inputRef?: RefObject<HTMLInputElement>;
}

export function VisibilityToggle({
	visible,
	setVisible,
	inputRef,
}: VisibilityToggleProps) {
	return (
		<button
			type="button"
			onClick={() => {
				setVisible(!visible);

				const input = inputRef?.current;
				if (input) {
					input.focus();
					setTimeout(() => {
						// move cursor to end of input
						input.selectionStart = input.selectionEnd = input.value.length;
					});
				}
			}}
			css={iconStyle}
		>
			{visible ? (
				<IconEyeSlash width={22} height={22} />
			) : (
				<IconEye width={22} height={22} />
			)}
		</button>
	);
}
